var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5C8.41421 2.5 8.75 2.83579 8.75 3.25V11.9393L9.96967 10.7197C10.2626 10.4268 10.7374 10.4268 11.0303 10.7197C11.3232 11.0126 11.3232 11.4874 11.0303 11.7803L8.53033 14.2803C8.23744 14.5732 7.76256 14.5732 7.46967 14.2803L4.96967 11.7803C4.67678 11.4874 4.67678 11.0126 4.96967 10.7197C5.26256 10.4268 5.73744 10.4268 6.03033 10.7197L7.25 11.9393V3.25C7.25 2.83579 7.58579 2.5 8 2.5Z",
    fill: "white",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLong);
export default __webpack_public_path__ + "static/media/arrow_long.20ada6c8462d5d0b635f3f887f62d8ea.svg";
export { ForwardRef as ReactComponent };